import axios from "@/plugins/axios.js";

export default {
  queryGwlb(param) {
    return axios.post("/Gwlb/queryGwlb", param);
  },
  doBm(param) {
    return axios.post("/Gwlb/doBm", param);
  },
  getAllCode: function() {
    return axios.post("/Sys/getAllCodeMap", {});
  },
  //文件上传
  uploadFile(param) {
    return axios.post("/file/uploadFile", param, {
      headers: {
        "Content-Type": "multipart/form-data;charset=UTF-8"
      }
    });
  },
  //文件删除
  delFile(param) {
    return axios.post("/file/delFile", param);
  },
  queryZsjRyxx(param) {
    return axios.post("/Gwlb/queryZsjRyxx", param);
  },
  queryUniversities(param) {
    return axios.post("/System/queryUniversities", param);
  },
  queryMajor(param) {
    return axios.post("/System/queryMajor", param);
  },
  queryZpgw(param) {
    return axios.post("/Gwlb/queryZpgw", param);
  },
  sendMessage(param) {
    return axios.post("/Gwlb/sendMessage", param);
  },
  //文件上传（上传至材料系统）
  setBMISection(param) {
    return axios.post("/file/setBMISection", param, {
      headers: {
        "Content-Type": "multipart/form-data;charset=UTF-8"
      }
    });
  },
  //保存报名信息
  doSaveShhzpBmxx(param) {
    return axios.post("/Smbm/doSaveShhzpBmxx", param);
  },
};
